const MESSAGE_RULES = [
  {
    match: /failed to fetch|networkerror|network request failed|load failed/i,
    title: 'Connection interrupted',
    description: 'Linkit could not reach the service. Check your connection and try again.',
    retryable: true,
  },
  {
    match: /rate limit|too many requests|shields active/i,
    title: 'Please wait before trying again',
    description: 'This action has been attempted too often. Wait a few minutes, then retry.',
    retryable: true,
  },
  {
    match: /invalid session|session expired|not authenticated|authentication required/i,
    title: 'Your session has expired',
    description: 'Sign in again to continue. Unsaved local changes may still be available on this device.',
    actionLabel: 'Sign in',
  },
  {
    match: /access denied|clearance|required permission|forbidden/i,
    title: 'You do not have access',
    description: 'Your account does not have permission to complete this action.',
  },
  {
    match: /not found|does not exist/i,
    title: 'This item is unavailable',
    description: 'It may have been removed, renamed, or you may no longer have access.',
  },
  {
    match: /already exists|duplicate|already joined|already taken/i,
    title: 'Already in use',
    description: 'Choose a different value or continue with the existing item.',
  },
  {
    match: /save failed|failed to save|could not save/i,
    title: 'Changes were not saved',
    description: 'Your current screen still contains the changes. Try saving again before leaving.',
    retryable: true,
  },
  {
    match: /copy failed|could not copy|clipboard/i,
    title: 'Could not copy',
    description: 'Select the value and copy it manually.',
  },
  {
    match: /camera permission|permission denied|notallowederror/i,
    title: 'Camera access is blocked',
    description: 'Allow camera access in your browser settings or use the manual option.',
  },
  {
    match: /passkey|webauthn|authenticator/i,
    title: 'Passkey verification did not finish',
    description: 'Keep the device prompt open and try again, or use another sign-in method.',
    retryable: true,
  },
];

const diagnosticReference = () => {
  const random = Math.random().toString(36).slice(2, 7).toUpperCase();
  return `LK-${Date.now().toString(36).toUpperCase()}-${random}`;
};

export function getErrorMessage(error) {
  if (typeof error === 'string') return error.trim();
  if (typeof error?.message === 'string') return error.message.trim();
  if (typeof error?.error === 'string') return error.error.trim();
  return '';
}

export function normalizeFeedbackError(error, fallback = {}) {
  const rawMessage = getErrorMessage(error);
  const matchedRule = MESSAGE_RULES.find((rule) => rule.match.test(rawMessage));
  const reference = diagnosticReference();

  return {
    title: fallback.title || matchedRule?.title || 'Something went wrong',
    description:
      fallback.description ||
      matchedRule?.description ||
      'The action could not be completed. Try again, or contact support if it continues.',
    actionLabel: fallback.actionLabel || matchedRule?.actionLabel,
    retryable: fallback.retryable ?? matchedRule?.retryable ?? false,
    reference,
    technicalMessage: rawMessage || 'Unknown error',
  };
}

export function createOperationMessage({
  title,
  description,
  state = 'info',
  actionLabel,
  reference,
}) {
  return {
    title,
    description,
    state,
    actionLabel,
    reference,
  };
}
